// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"BlogPop_ConfirmationPop__iBWsC","modalBody":"BlogPop_modalBody__2Zfu9"};